/**
 * Webpack recommends using an asynchronous boundary
 * as the entry point to the application when using
 * module federation for micro-frontends
 */
import("./bootstrap");
